<script>

	import PreLoad from "./preload/PreLoad.svelte";
	import SiteController from "./SiteController.svelte";

	let percentComplete = 0;
	let images;

	let showLoader = true;

	$: percentValue = Math.round(percentComplete) + '%';

	$: {
		if (percentComplete === 100) {
			setTimeout(() => {
				showLoader = false
			}, 150);
		}
	}

	function handlePercentComplete(percent) {
		percentComplete = percent.detail.percent;
	}

</script>

<PreLoad on:percentComplete={handlePercentComplete} />

{#if showLoader}
	<section class="container">
		<h2>Loading... {percentValue}</h2>
		<div class="load-container">
			<div class="load-bar" style={'width: ' + percentValue}></div>
		</div>
	</section>
{:else}
	<SiteController />
{/if}


<style>
	.container {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-content: center;
		color: white;
		flex-direction: column;
	}

	h2 {
		width: 100%;
		max-width: 200px;
		margin: 0 auto;
		font-weight: 400;

	}

	.load-container {
		position: relative;
		width: 100%;
		max-width: 200px;
		margin: 0 auto;
		background: black;
		height: 5px;
		border-radius: 10px;
	}

	.load-bar {
		position: absolute;
		left: 0;
		top: 0;
		background: white;
		height: 5px;
		border-radius: 10px;
		transition: width 150ms ease-out;
	}
</style>